import React from 'react';
import { useTenant } from '../contexts/TenantContext';
import { platformUrl } from '../utils/tenantHost';

// Shown on a subdomain that doesn't match any active tenant.
const TenantNotFound = () => {
  const { subdomain } = useTenant();

  return (
    <div className="unauth-page">
      <div className="unauth-inner">
        <div className="unauth-icon">🏥</div>
        <h2 className="unauth-title">Clinic not found</h2>
        <p className="unauth-sub">
          There is no active clinic at <strong>{window.location.host}</strong>
          {subdomain ? ` ("${subdomain}")` : ''}. Check the address your clinic shared with you.
        </p>
        <a className="btn-primary btn-auto" href={platformUrl()} style={{ display: 'inline-block', textDecoration: 'none' }}>
          Go to ArogyaOne home
        </a>
      </div>
    </div>
  );
};

export default TenantNotFound;
